<template>
	<div class="applications">
		<ul class="applications__list" v-if="summaryFeatures && summaryFeatures.length > 0">
			<li v-for="(sa, i) in summaryFeatures" :key="i">{{ Object.keys(sa)[0] }}<span v-if="!Object.keys(sa)[0].includes('?')">:</span>&nbsp;{{ Object.values(sa)[0] }}</li>
		</ul>
		<div class="empty" v-else>
			<div>Esse produto não possui características cadastradas.</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		summaryFeatures: {
			type: Array,
			default: [],
		},
	},
}
</script>

<style scoped lang="scss">
.empty {
	font-size: 16px;
	line-height: 20px;
	color: #3c484d;
	font-family: var(--head-regular);
}

@media (max-width: 767px) {
	.empty {
		font-size: 16px;
		line-height: 20px;
	}
}
.applications {
	p {
		font-size: 16px;
		line-height: 20px;
		color: #3c484d;
		padding: 0;
		margin-bottom: 16px;
	}
	&__list {
		display: grid;
		row-gap: 16px;
		padding: 0px 0px 0px 8px;
		li {
			&::before {
				content: "•";
				transform: translateY(-0.05em);
				font-weight: bold;
				margin-right: 8px;
			}
			font-family: var(--head-regular);
			font-size: 16px;
			line-height: 1;
			color: #3c484d;
		}
	}
}
</style>
